import React from 'react'

const Contact = () => {
  return (
    <section className='component-contact relative mx-auto max-w-screen-xl py-3 px-4'>
      <div className='border-4 border-orange-200 bg-white'>
        <form name='contact' className='p-4 pt-0' method='POST' action='/success' data-netlify='true' data-netlify-honeypot='surname'>
          <input type='hidden' name='surname' />
          <input type='hidden' name='form-name' value='contact' />
          <div className='mb-4'>
            <label className='mt-5 mb-3 block font-normal' htmlFor='name'>
              What's your name?
            </label>
            <input className='w-full appearance-none rounded-md border py-3 px-5 focus:outline-none focus:ring md:w-1/2' type='text' name='name' id='name' required />
          </div>
          <div className='mb-4'>
            <label className='mt-5 mb-3 block font-normal' htmlFor='email'>
              What's your email address?
            </label>
            <input className='w-full appearance-none rounded-md border py-3 px-5 focus:outline-none focus:ring md:w-2/3' type='email' name='email' id='email' required />
          </div>
          <div className='mb-4'>
            <label className='mt-5 mb-3 block font-normal' htmlFor='message'>
              Your message
            </label>
            <textarea
              className='w-full appearance-none rounded-md border py-3 px-5 focus:outline-none focus:ring'
              name='message'
              id='message'
              placeholder='Please provide as much information as possible'
              required></textarea>
          </div>
          <button type='submit' className='button'>
            Send
          </button>
        </form>
      </div>
    </section>
  )
}

export default React.memo(Contact)
